module.exports = __webpack_public_path__ + "static/media/apple_tv_accessories_dark.f7629e85.svg";